
// FeCon base shim and jQuery  START
import 'es5-shim/es5-shim';
import 'es5-shim/es5-sham';

//import jQuery here to assure it's loaded before angular
import jquery from 'jquery';
window.$ = window.jQuery = jquery;
require('jquery.cookie');
require('block-ui');
// FeCon base shim and jQuery  /END

// FeCon - matchmedia IE9 polyfill
require('matchmedia-polyfill');
require('../node_modules/matchmedia-polyfill/matchMedia.addListener.js');

// Polyfills
// (these modules are what are in 'angular2/bundles/angular2-polyfills' so don't use that here)

// import 'ie-shim'; // Internet Explorer
// import 'es6-shim';
// import 'es6-promise';
// import 'es7-reflect-metadata';

// Prefer CoreJS over the polyfills above
import 'core-js/es6';
import 'core-js/es7/reflect';
// require('zone.js/dist/zone');


if(!ENV) {
  var ENV = 'development';
}

if(ENV === 'production') {
  // Production
} else {
  // Development


  Error.stackTraceLimit = Infinity;

  // require('zone.js/dist/long-stack-trace-zone');
}

// FeCon - IE9 console patch -- START
const _ = require('lodash');

let methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' +
  'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' +
  'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn').split(',');

const console = window.console;
_.forEach(methods, prop => {
  if(!console[prop]) console[prop] = function empty() {};
  else {
    const originalMethod = console[prop];
    console[prop] = function() {
      var args = [].slice.call(arguments);
      // IE9 doesn't allow calling apply on console functions directly
      // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
      Function.prototype.bind
        .call(originalMethod, window.console)
        .apply(window.console, args);
    };
  }
});
// FeCon - IE9 console patch -- /END



// WEBPACK FOOTER //
// ./client/polyfills.js